module.exports = __webpack_public_path__ + "img/undraw_click_here.245924d3.svg";